import { useSelector, useDispatch } from 'react-redux';
import type { AppState, AppDispatch } from '@nextgen-web-framework/core';
import { OtpVerification } from '@commerce-identity-webcomponents/ui';
import { updateRegistrationData } from '@commerce-profile-webcomponents/sdk';
import { RegistrationOTPWrapperProps } from './types/propTypes';

export const RegistrationOTPWrapper = ({
  username,
  challengeId,
  nextHandler,
  onCloseDrawer,
  showChangeCTA = true,
  onUsernameChangeHandler,
  usernameType = undefined,
}: RegistrationOTPWrapperProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const registrationFlow = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  const changeUserNameHandler = () => {
    onUsernameChangeHandler?.();
    dispatch(
      updateRegistrationData({
        ...registrationFlow,
        isChangeUsernameModalOpen: true,
      }),
    );
  };
  const otpVerifiedHandler = () => {
    setTimeout(() => nextHandler(), 0);
  };

  return (
    <OtpVerification
      challengeId={challengeId}
      username={username as string}
      callback={otpVerifiedHandler}
      autoverify={true}
      showChangeCTA={showChangeCTA}
      onChangeCTA={changeUserNameHandler}
      onClose={onCloseDrawer}
      {...(usernameType && { usernameType })}
    />
  );
};
export default RegistrationOTPWrapper;
